import React, { useEffect, useState } from "react";
import axios from "../api/axios";
import { useNavigate } from "react-router-dom";
import EmailModal from "../components/EmailModal";
import "../styles/theme-dark.css";

export default function Correo() {
  const navigate = useNavigate();

  const [tab, setTab] = useState("inbox");
  const [emails, setEmails] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [viewer, setViewer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [draft, setDraft] = useState(null);

  /* ============================================================
     CARGAR CORREOS
  ============================================================ */
  useEffect(() => {
    cargarCorreos(tab);
  }, [tab]);

  async function cargarCorreos(tipo) {
    try {
      setSelectedEmail(null);
      setViewer(null);
      setLoading(true);

      const r = await axios.get(`/mail/${tipo}`);
      setEmails(r.data.emails || []);
    } catch (err) {
      console.error("Error cargando correos:", err);
    } finally {
      setLoading(false);
    }
  }

  /* ============================================================
     FILTRO BUSCADOR
  ============================================================ */
  const filteredEmails = emails.filter((mail) => {
    const q = search.toLowerCase();
    return (
      mail.subject?.toLowerCase().includes(q) ||
      mail.from?.toLowerCase().includes(q) ||
      mail.to?.toLowerCase().includes(q) ||
      mail.date?.toLowerCase().includes(q) ||
      mail.text?.toLowerCase().includes(q) ||
      mail.attachments?.some(att =>
        att.filename?.toLowerCase().includes(q)
      )
    );
  });

  /* ============================================================
     SELECCIONAR CORREO
  ============================================================ */
  async function handleSelectEmail(mail) {
    setSelectedEmail(mail);
    setViewer(null);

    if (mail.isSeen) return;

    try {
      await axios.post("/mail/mark-seen", {
        box: tab === "inbox" ? "INBOX" : "Sent",
        uid: mail.id,
      });

      setEmails((prev) =>
        prev.map((m) => (m.id === mail.id ? { ...m, isSeen: true } : m))
      );
    } catch (err) {
      console.error("Error marcando como leído:", err);
    }
  }

  /* ============================================================
     BORRAR CORREO
  ============================================================ */
  async function handleDeleteEmail() {
    if (!selectedEmail) return;

    const ok = window.confirm("¿Seguro que deseas borrar este correo?");
    if (!ok) return;

    try {
      await axios.post("/mail/delete", {
        box: tab === "inbox" ? "INBOX" : "Sent",
        uid: selectedEmail.id,
      });

      setEmails((prev) => prev.filter((m) => m.id !== selectedEmail.id));
      setSelectedEmail(null);
      setViewer(null);
    } catch (err) {
      console.error("Error borrando correo:", err);
    }
  }

  /* ============================================================
     RESPONDER
  ============================================================ */
  function handleReply() {
    if (!selectedEmail) return;

    setDraft({
      to: selectedEmail.from,
      subject: `RE: ${selectedEmail.subject}`,
      body:
        `<br><br>--- Mensaje original ---<br>` +
        `<strong>De:</strong> ${selectedEmail.from}<br>` +
        `<strong>Fecha:</strong> ${selectedEmail.date}<br><br>` +
        (selectedEmail.html || selectedEmail.text || ""),
      attachments: [],
    });

    setOpenEmailModal(true);
  }

  /* ============================================================
     REENVIAR
  ============================================================ */
  function handleForward() {
    if (!selectedEmail) return;

    setDraft({
      to: "",
      subject: `FWD: ${selectedEmail.subject}`,
      body:
        `<br><br>--- Mensaje reenviado ---<br><br>` +
        (selectedEmail.html || selectedEmail.text || ""),
      attachments: selectedEmail.attachments || [],
    });

    setOpenEmailModal(true);
  }

  /* ============================================================
   NUEVO CORREO
============================================================ */
function handleNewEmail() {
  setDraft({
    to: "",
    subject: "",
    body: "",
    attachments: [],
  });

  setOpenEmailModal(true);
}


  /* ============================================================
     VISOR PDF/IMAGEN
  ============================================================ */
  function openViewer(box, emailId, index, filename) {
    const ext = filename.toLowerCase();
    const previewable = [".pdf", ".jpg", ".jpeg", ".png", ".gif", ".webp"];

    if (!previewable.some((e) => ext.endsWith(e))) {
      return alert("Este adjunto solo puede descargarse.");
    }

    const url = `http://localhost:5000/api/mail/view/${box}/${emailId}/${index}`;

    setViewer({
      url,
      filename,
      type: ext.endsWith(".pdf") ? "pdf" : "img",
    });
  }

  return (
    <div className="page-dark" style={{ padding: 16 }}>
      {/* HEADER */}
      <header
        style={{
          padding: "18px 24px",
          marginBottom: 20,
          background: "rgba(15,23,42,0.65)",
          borderBottom: "1px solid rgba(255,255,255,0.12)",
          backdropFilter: "blur(10px)",
          borderRadius: "0 0 16px 16px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.45)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <img src="/corex-logo.png" alt="COREX" style={{ height: 40 }} />
          <div>
            <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700 }}>
              Gestor de correo
            </h1>
            <p style={{ opacity: 0.7, marginTop: 4 }}>
              Visualiza emails recibidos y enviados desde tu cuenta IMAP.
            </p>
          </div>
        </div>

        <button
          onClick={() => navigate("/dashboard")}
          style={{
            padding: "10px 18px",
            background: "rgba(255,255,255,0.1)",
            color: "white",
            fontSize: 14,
            borderRadius: 10,
            border: "1px solid rgba(255,255,255,0.25)",
            cursor: "pointer",
          }}
        >
          ← Menú principal
        </button>
      </header>

      {/* DISEÑO PRINCIPAL */}
      <div
        style={{
          display: "grid",
          gridTemplateRows: "44px 1fr",
          gridTemplateColumns: "260px 1fr",
          gap: 16,
          height: "calc(100vh - 120px)",
        }}
      >
        {/* PESTAÑAS */}
        <div
          style={{
            gridColumn: "1 / span 2",
            display: "flex",
            gap: 12,
            alignItems: "center",
          }}
        >
          <button
  className="glass-btn"
  style={{
    padding: "6px 14px",
    fontSize: 14,
    background: "rgba(34,197,94,0.45)",
    border: "1px solid rgba(34,197,94,0.7)",
  }}
  onClick={handleNewEmail}
>
  ✉ Nuevo
</button>

          <button
            className="glass-btn"
            style={{
              padding: "6px 14px",
              fontSize: 14,
              background:
                tab === "inbox"
                  ? "rgba(59,130,246,0.6)"
                  : "rgba(255,255,255,0.12)",
            }}
            onClick={() => setTab("inbox")}
          >
            📥 Recibidos
          </button>

          <button
            className="glass-btn"
            style={{
              padding: "6px 14px",
              fontSize: 14,
              background:
                tab === "sent"
                  ? "rgba(59,130,246,0.6)"
                  : "rgba(255,255,255,0.12)",
            }}
            onClick={() => setTab("sent")}
          >
            📤 Enviados
          </button>
        </div>

        {/* LISTA IZQUIERDA */}
        <div
          className="glass-box"
          style={{
            overflowY: "auto",
            padding: 12,
            display: "flex",
            flexDirection: "column",
            gap: 8,
          }}
        >
          {/* BUSCADOR */}
          <input
            type="text"
            placeholder="Buscar..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              padding: "6px 10px",
              marginBottom: 10,
              borderRadius: 8,
              border: "1px solid rgba(255,255,255,0.15)",
              background: "rgba(255,255,255,0.05)",
              color: "white",
              fontSize: 13,
            }}
          />

          {loading && <p>Cargando correos…</p>}
          {!loading && filteredEmails.length === 0 && (
            <p style={{ opacity: 0.7 }}>No hay correos.</p>
          )}

          {!loading &&
            filteredEmails.map((mail) => (
              <div
                key={mail.id}
                onClick={() => handleSelectEmail(mail)}
                style={{
                  padding: 10,
                  borderRadius: 10,
                  border: "1px solid rgba(255,255,255,0.12)",
                  background:
                    selectedEmail?.id === mail.id
                      ? "rgba(59,130,246,0.25)"
                      : "rgba(255,255,255,0.06)",
                  cursor: "pointer",
                }}
              >
                <div style={{ fontSize: 13, fontWeight: 700 }}>
                  {mail.isSeen ? "⚪ " : "🔵 "}
                  {mail.subject || "(Sin asunto)"}
                </div>

                <div
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    opacity: 0.85,
                  }}
                >
                  {tab === "inbox" ? mail.from : mail.to}
                </div>

                <div style={{ fontSize: 11, opacity: 0.5 }}>
                  {mail.date}
                </div>
              </div>
            ))}
        </div>

        {/* PANEL DERECHO */}
        <div className="glass-box" style={{ padding: 12, overflowY: "auto" }}>
          {!selectedEmail ? (
            <p style={{ opacity: 0.6 }}>Selecciona un correo para leerlo.</p>
          ) : (
            <>
              {/* ENCABEZADO */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h2 style={{ marginTop: 0 }}>{selectedEmail.subject}</h2>

                {/* BOTONES */}
                <div style={{ display: "flex", gap: 10 }}>
                  <button
                    onClick={handleReply}
                    style={{
                      padding: "6px 12px",
                      background: "rgba(59,130,246,0.3)",
                      borderRadius: 8,
                      border: "1px solid rgba(59,130,246,0.5)",
                      cursor: "pointer",
                      color: "white",
                    }}
                  >
                    🖊 Responder
                  </button>

                  <button
                    onClick={handleForward}
                    style={{
                      padding: "6px 12px",
                      background: "rgba(59,130,246,0.3)",
                      borderRadius: 8,
                      border: "1px solid rgba(59,130,246,0.5)",
                      cursor: "pointer",
                      color: "white",
                    }}
                  >
                    ↪ Reenviar
                  </button>

                  <button
                    onClick={handleDeleteEmail}
                    style={{
                      padding: "6px 12px",
                      background: "rgba(255,80,80,0.2)",
                      borderRadius: 8,
                      border: "1px solid rgba(255,80,80,0.4)",
                      cursor: "pointer",
                      color: "white",
                    }}
                  >
                    🗑 Borrar
                  </button>
                </div>
              </div>

              {/* ADJUNTOS ARRIBA */}
              {selectedEmail.attachments?.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 8,
                    marginBottom: 12,
                  }}
                >
                  {selectedEmail.attachments.map((a, idx) => (
                    <div
                      key={idx}
                      onClick={() =>
                        openViewer(
                          tab === "inbox" ? "INBOX" : "Sent",
                          selectedEmail.id,
                          idx,
                          a.filename
                        )
                      }
                      style={{
                        background: "rgba(255,255,255,0.08)",
                        padding: "4px 8px",
                        borderRadius: 8,
                        fontSize: 12,
                        border: "1px solid rgba(255,255,255,0.15)",
                        cursor: "pointer",
                      }}
                    >
                      📎 {a.filename}
                    </div>
                  ))}
                </div>
              )}

              {/* VISOR */}
              {viewer && (
                <div
                  style={{
                    padding: 12,
                    marginBottom: 20,
                    background: "rgba(255,255,255,0.05)",
                    borderRadius: 10,
                    border: "1px solid rgba(255,255,255,0.1)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 10,
                    }}
                  >
                    <strong>📄 {viewer.filename}</strong>

                    <button
                      onClick={() => setViewer(null)}
                      style={{
                        padding: "6px 12px",
                        background: "rgba(255,80,80,0.2)",
                        borderRadius: 8,
                        border: "1px solid rgba(255,80,80,0.4)",
                        cursor: "pointer",
                        color: "white",
                      }}
                    >
                      ✖ Cerrar visor
                    </button>
                  </div>

                  {viewer.type === "pdf" ? (
                    <iframe
                      src={viewer.url}
                      style={{
                        width: "100%",
                        height: "600px",
                        borderRadius: 8,
                        border: "1px solid rgba(255,255,255,0.15)",
                      }}
                    />
                  ) : (
                    <img
                      src={viewer.url}
                      style={{
                        maxWidth: "100%",
                        borderRadius: 10,
                        border: "1px solid rgba(255,255,255,0.15)",
                      }}
                    />
                  )}
                </div>
              )}

              {/* METADATOS */}
              <p style={{ opacity: 0.7, marginBottom: 4 }}>
                <strong>De:</strong> {selectedEmail.from}
              </p>

              <p style={{ opacity: 0.7, marginBottom: 4 }}>
                <strong>Para:</strong> {selectedEmail.to}
              </p>

              <p style={{ opacity: 0.7, marginBottom: 12 }}>
                <strong>Fecha:</strong> {selectedEmail.date}
              </p>

              {/* CONTENIDO */}
              <div
                style={{
                  borderTop: "1px solid rgba(255,255,255,0.12)",
                  paddingTop: 12,
                }}
                dangerouslySetInnerHTML={{
                  __html:
                    selectedEmail.html ||
                    selectedEmail.text?.replace(/\n/g, "<br>") ||
                    "(Sin contenido)",
                }}
              />
            </>
          )}
        </div>
      </div>

      {/* MODAL DE ENVÍO */}
      {openEmailModal && (
        <EmailModal
          onClose={() => setOpenEmailModal(false)}
          preset={draft}
        />
      )}
    </div>
  );
}
